import Vue from "vue";
import VueI18n from "vue-i18n";
import AppLocales from "../locales";

Vue.use(VueI18n);
var curLocale = localStorage.getItem('locale') ? localStorage.getItem('locale') : navigator.language.split('-')[0];

if (curLocale != "tr" && curLocale != "en" && curLocale != "ar")
    curLocale = "tr";

export default new VueI18n({
    locale: curLocale ? curLocale : (window.lang && window.lang.name) || "tr",
    fallbackLocale: curLocale ? curLocale : (window.lang && window.lang.name) || "tr",
    messages: AppLocales
});